import { ANALYTICS_CHANNEL } from '../../../../../utils/analytics';
const createTrackRelatedLinksLoadedEventPayload = ({
  relatedLinksCount
}) => ({
  action: 'loaded',
  actionSubject: 'relatedLinks',
  eventType: 'track',
  attributes: {
    relatedLinksCount
  }
});
export const fireRelatedLinksLoadedEvent = createAnalyticsEvent => attributes => {
  const payload = createTrackRelatedLinksLoadedEventPayload(attributes);
  if (payload) {
    createAnalyticsEvent({
      ...payload
    }).fire(ANALYTICS_CHANNEL);
  }
};